<!-- //
字典详情
@author xuyd
@date 2025-05-31
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="opts.title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="800px">
    <div>
      <el-form ref="refForm" :model="form" :rules="rules" size="small" label-width="120px">
        <el-form-item prop="dictType" label="字典类型">
          <el-input v-model="form.dictType" style="width: 100%;" maxlength="30"/>
        </el-form-item>
        <el-form-item prop="typeName" label="类型名称">
          <el-input v-model="form.typeName" style="width: 100%;" maxlength="50"/>
        </el-form-item>
        <el-form-item prop="dictValue" label="字典值">
          <el-input v-model="form.dictValue" style="width: 100%;" maxlength="50"/>
        </el-form-item>
        <el-form-item prop="dictLabel" label="字典显示内容">
          <el-input v-model="form.dictLabel" style="width: 100%;" maxlength="255"/>
        </el-form-item>
        <el-form-item prop="dictStyle" label="字典样式">
          <el-input v-model="form.dictStyle" style="width: 100%;" maxlength="100" placeholder="class样式：primary/danger/normal/info/warning"/>
        </el-form-item>
        <el-form-item prop="sort" label="字典排序">
          <el-input v-model="form.sort" style="width: 100%;" maxlength="3"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button type="primary" size="small" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import DictApi from "@/api/sys/sysDict.api.js";

export default {
  name: 'ViewDictDetail',
  components: {},
  data() {
    return {
      visible: false,
      opts: {
        title: '添加应用',
        mode: null,
      },
      form: {
        id: null,
        dictType: null,
        typeName: null,
        dictValue: null,
        dictLabel: null,
      },
      rules: {
        dictType: [{required: true, message: "请输入字典类型", trigger: 'blur'}],
        typeName: [{required: true, message: "请输入字典类型名称", trigger: 'blur'}],
        dictValue: [{required: true, message: "请输入字典值", trigger: 'blur'}],
        dictLabel: [{required: true, message: "请输入字典显示内容", trigger: 'blur'}],
      },
    }
  },

  methods: {
    showModal({mode, title, data, onOk}) {
      let that = this;
      this.opts.title = title
      this.opts.mode = mode
      this.opts.onOk = onOk
      this.opts.onCancel = null

      this.dialogShow({
        data: data,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    /**
     * 业务数据data处理
     *
     * @param opts
     */
    dialogShow(opts) {
      this.visible = true;
      if (!opts.data) {
        opts.data = {};
      }
      let form = {};
      let keys = Object.keys(this.form);
      keys.forEach(k => {
        form[k] = opts.data[k]
      })
      this.form = form;
      console.log("----form---->", this.form);
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
    },

    /**
     * 点击确定
     */
    handleOk() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          return DictApi.saveDict(this.form).then((resp) => {
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          });
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
